import { Coordinator } from '../interfaces';
import { useCoordinator } from './useCoordinator';

export function useConferenceInstance<T extends Coordinator.Conference.Instance = Coordinator.Conference.Instance>() {
  const coordinator = useCoordinator();
  return coordinator.state.conference as T;
}